import { ShoppingBasket } from '../icons/shopping-basket';
import { CoinBackground } from './coin-background';

export const VirtualCurrencyCard = ({
  title,
  description,
  formattedPrice,
  onPurchaseButtonClick,
}: {
  title: string;
  description: string;
  formattedPrice: string;
  onPurchaseButtonClick: () => Promise<void>;
}) => {
  return (
    <div className="relative rounded-[10px] overflow-hidden border border-dark-7 transition-all duration-300 ease-out group hover:border-customgreen pb-3 w-72">
      <div>
        <CoinBackground />
      </div>
      <div className="mx-3 mt-3">
        <div className="text-white text-xl font-semibold">{title}</div>
        <div className="text-[#868686] text-sm pb-4">{description}</div>
        <svg width="164" height="1" viewBox="0 0 164 1" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M0 0.25H164" stroke="#2D2D31" stroke-width="0.5" />
        </svg>
        <button
          className="bg-customgreen text-customdarkgray w-full rounded-3xl py-2 px-3 font-bold transform transition duration-300 ease-out hover:scale-[1.03] flex flex-row mt-2 justify-center"
          onClick={async () => await onPurchaseButtonClick()}
        >
          <div className="pt-1 pr-2">
            <ShoppingBasket />
          </div>
          <div>Buy for {formattedPrice}</div>
        </button>
      </div>
    </div>
  );
};
